import { RootStateOrAny } from "react-redux";
import { encryptFieldsIfNeeded } from "../../js/encryption";
import lodash from "lodash";

interface dataToSaveProps {
  apiPath: string;
  primaryKey: string;
  primaryKeyValue: string;
  foreignKey: string;
  foreignKeyValue: string;
  dataAttributeName: string;
  data: object;
  errors: string[];
}
interface ConfigurationPluginDataState {
  dataToSave: dataToSaveProps;
}

export const configurationPluginData = {
  state: { dataToSave: {} },
  reducers: {
    setSaveData: (currentState: ConfigurationPluginDataState, dataToSave: dataToSaveProps) => {
      const newConfigurationPluginData = { ...currentState };
      const newDataToSave = { ...newConfigurationPluginData.dataToSave };

      newDataToSave.data = dataToSave.data;
      newDataToSave.errors = dataToSave.errors;

      newConfigurationPluginData.dataToSave = Object.assign(newConfigurationPluginData.dataToSave, newDataToSave);

      return newConfigurationPluginData;
    },
    setSaveKeys(
      currentState: ConfigurationPluginDataState,
      {
        apiPath,
        primaryKey,
        primaryKeyValue,
        foreignKey,
        foreignKeyValue,
        dataAttributeName
      }: {
        apiPath: string;
        primaryKey: string;
        primaryKeyValue: string;
        foreignKey: string;
        foreignKeyValue: string;
        dataAttributeName: string;
      }
    ) {
      const newConfigurationPluginData = { ...currentState };
      const { dataToSave } = newConfigurationPluginData;

      dataToSave.primaryKey = primaryKey;
      dataToSave.primaryKeyValue = primaryKeyValue;
      dataToSave.foreignKey = foreignKey;
      dataToSave.foreignKeyValue = foreignKeyValue;
      dataToSave.apiPath = apiPath;
      dataToSave.dataAttributeName = dataAttributeName;

      return newConfigurationPluginData;
    },
    encryptFields: (currentState: ConfigurationPluginDataState, dataSchemaAttributes, dataAttributeName: string) => {
      const newConfigurationPluginData = { ...currentState };
      const { data } = newConfigurationPluginData.dataToSave;

      const encryptedData = encryptFieldsIfNeeded(dataAttributeName ? lodash.set({}, dataAttributeName, data) : data, dataSchemaAttributes);

      newConfigurationPluginData.dataToSave.data = dataAttributeName ? lodash.get(encryptedData, dataAttributeName) : encryptedData;

      return newConfigurationPluginData;
    }
  },
  effects: (dispatch) => {
    return {
      prepareDataToSave: (payload: dataToSaveProps, rootState: RootStateOrAny) => {
        dispatch.configurationPluginData.setSaveData({ ...payload });

        if (rootState.configurationPluginLoader.isInitialLoading) dispatch.configurationPluginLoader.setIsInitialLoading(false);
        else if (rootState.configurationPluginLoader.isSaveEnabled !== (payload.errors.length === 0))
          dispatch.configurationPluginLoader.setIsSaveEnabled(payload.errors.length === 0);
      }
    };
  }
};

export default configurationPluginData;
